<section>
  <h1>{{ 'ON_BOARDING.STEPPER.COMPLETED.NOW_YES' | translate }}</h1>
  <h1>{{ 'ON_BOARDING.STEPPER.COMPLETED.YOU_ARE_READY' | translate }}</h1>
  <p>{{ 'ON_BOARDING.STEPPER.COMPLETED.FIRST_DAY_ACCESS_INFO' | translate }}</p>
  <div class="imgs-container">
    <img src="assets/imgs/on-boarding/code_autentication.svg" alt="Woman with tablet" />
    <ng-lottie height="400px" [options]="options"> </ng-lottie>
  </div>
</section>
